<template>
	<div class="result-detail">
		<!--///////////////////////// RESULT01：SACRIFICE MIND /////////////////////////-->
		<div class="sacrifice-mind" v-if="resultDetailNow==1">
			<ResultDetailTitle v-bind:resultDetailNow="resultDetailNow"></ResultDetailTitle>
			<!-- +++++++ 01-01：内向性 × 他人本位 ++++++++ -->
			<div v-if="levelResult.percentage >= 50 && sacrificeMindResult.percentageLeft >= 50">
				<ResultDetailSacrificeInLeft></ResultDetailSacrificeInLeft>
			</div>
			<!-- +++++++ 01-02：内向性 × 自己本位 ++++++++ -->
			<div v-if="levelResult.percentage >= 50 && sacrificeMindResult.percentageLeft < 50">
				<ResultDetailSacrificeInRight></ResultDetailSacrificeInRight>
			</div>
			<!-- +++++++ 01-03：外向性 × 他人本位 ++++++++ -->
			<div v-if="levelResult.percentage < 50 && sacrificeMindResult.percentageLeft >= 50">
				<ResultDetailSacrificeOutLeft></ResultDetailSacrificeOutLeft>
			</div>
			<!-- +++++++ 01-04：外向性 × 自己本位 ++++++++ -->
			<div v-if="levelResult.percentage < 50 && sacrificeMindResult.percentageLeft < 50">
				<ResultDetailSacrificeOutRight></ResultDetailSacrificeOutRight>
			</div>
			<h4 class="next-catch">次は、あなたの内向性と「自己投資」の診断結果です！</h4>
			<button class="next" v-on:click="resultDetailNowPlus">
				診断結果の続きを見る
			</button>
			<router-link class="prev" to="/result-index">
				前へ戻る
			</router-link>
		</div><!-- end .sacrifice-mind -->
		<!--///////////////////////// RESULT02：INVEST MIND /////////////////////////-->
		<div class="invest-mind" v-if="resultDetailNow==2">
			<ResultDetailTitle v-bind:resultDetailNow="resultDetailNow"></ResultDetailTitle>
			<!-- +++++++ 02-01：内向性 × 変革型 ++++++++ -->
			<div v-if="levelResult.percentage >= 50 && investMindResult.percentageLeft >= 50">
				<ResultDetailInvestInLeft></ResultDetailInvestInLeft>
			</div>
			<!-- +++++++ 02-02：内向性 × 保守型 ++++++++ -->
			<div v-if="levelResult.percentage >= 50 && investMindResult.percentageLeft < 50">
				<ResultDetailInvestInRight></ResultDetailInvestInRight>
			</div>
			<!-- +++++++ 02-03：外向性 × 変革型 ++++++++ -->
			<div v-if="levelResult.percentage < 50 && investMindResult.percentageLeft >= 50">
				<ResultDetailInvestOutLeft></ResultDetailInvestOutLeft>
			</div>
			<!-- +++++++ 02-04：外向性 × 保守型 ++++++++ -->
			<div v-if="levelResult.percentage < 50 && investMindResult.percentageLeft < 50">
				<ResultDetailInvestOutRight></ResultDetailInvestOutRight>
			</div>
			<h4 class="next-catch">次は、あなたの内向性と「コミュニケーション」の診断結果です！</h4>
			<button class="next" v-on:click="resultDetailNowPlus">
				診断結果の続きを見る
			</button>
			<button class="prev" v-on:click="resultDetailNowMinus">
				前へ戻る
			</button>
		</div><!-- end .invest-mind -->
		<!--///////////////////////// RESULT03：COMMUNICATION /////////////////////////-->
		<div class="communication" v-if="resultDetailNow==3">
			<ResultDetailTitle v-bind:resultDetailNow="resultDetailNow"></ResultDetailTitle>
			<!-- +++++++ 03-01：内向性 × 積極型 ++++++++ -->
			<div v-if="levelResult.percentage >= 50 && communicateResult.percentageLeft >= 50">
				<ResultDetailCommunicationInLeft></ResultDetailCommunicationInLeft>
			</div>
			<!-- +++++++ 03-02：内向性 × 独立型 ++++++++ -->
			<div v-if="levelResult.percentage >=50 && communicateResult.percentageLeft < 50">
				<ResultDetailCommunicationInRight></ResultDetailCommunicationInRight>
			</div>
			<!-- +++++++ 03-03：外向性 × 変革型 ++++++++ -->
			<div v-if="levelResult.percentage < 50 && communicateResult.percentageLeft >= 50">
				<ResultDetailCommunicationOutLeft></ResultDetailCommunicationOutLeft>
			</div>
			<!-- +++++++ 03-02：外向性 × 変革型 ++++++++ -->
			<div v-if="levelResult.percentage < 50 && communicateResult.percentageLeft < 50">
				<ResultDetailCommunicationOutRight></ResultDetailCommunicationOutRight>
			</div>
			<h4 class="next-catch">次は、あなたの内向性と「アウトプット」の診断結果です！</h4>
			<button class="next" v-on:click="resultDetailNowPlus">
				診断結果の続きを見る
			</button>
			<button class="prev" v-on:click="resultDetailNowMinus">
				前へ戻る
			</button>
		</div><!-- end .communication -->
		<!--///////////////////////// RESULT04：OUTPUT /////////////////////////-->
		<div class="output" v-if="resultDetailNow==4">
			<ResultDetailTitle v-bind:resultDetailNow="resultDetailNow"></ResultDetailTitle>
			<!-- +++++++ 04-01：内向性 × 創出型 ++++++++ -->
			<div v-if="levelResult.percentage >= 50 && outputResult.percentageLeft >= 50">
				<ResultDetailOutputInLeft></ResultDetailOutputInLeft>
			</div>
			<!-- +++++++ 04-02：内向性 × 操縦型 ++++++++ -->
			<div v-if="levelResult.percentage >= 50 && outputResult.percentageLeft < 50">
				<ResultDetailOutputInRight></ResultDetailOutputInRight>
			</div>
			<!-- +++++++ 04-03：外向性 × 創出型 ++++++++ -->
			<div v-if="levelResult.percentage < 50 && outputResult.percentageLeft >= 50">
				<ResultDetailOutputOutLeft></ResultDetailOutputOutLeft>
			</div>
			<!-- +++++++ 04-04：外向性 × 操縦型 ++++++++ -->
			<div v-if="levelResult.percentage < 50 && outputResult.percentageLeft < 50">
				<ResultDetailOutputOutRight></ResultDetailOutputOutRight>
			</div>
			<h4 class="next-catch">さて、診断はこれで終わりですが…</h4>
			<button class="next" v-on:click="resultDetailNowPlus">
				最後にあなたへ
			</button>
			<button class="prev" v-on:click="resultDetailNowMinus">
				前へ戻る
			</button>
		</div><!-- end .output -->
		<!--///////////////////////// RESULT05：LAST MESSAGE /////////////////////////-->
		<div class="last-message" v-if="resultDetailNow==5">
			<ResultDetailTitle v-bind:resultDetailNow="resultDetailNow"></ResultDetailTitle>
			<ResultDetailLastMessage></ResultDetailLastMessage>
			<button class="prev" v-on:click="resultDetailNowMinus">
				前へ戻る
			</button>
		</div><!-- end .last-message -->				
	</div><!-- end .result-detail -->
</template>

<script>

import ResultDetailTitle from '../components/ResultDetailTitle.vue'
//自己犠牲マインドの結果詳細
import ResultDetailSacrificeInLeft from '../components/ResultDetailSacrificeInLeft.vue'
import ResultDetailSacrificeInRight from '../components/ResultDetailSacrificeInRight.vue'
import ResultDetailSacrificeOutLeft from '../components/ResultDetailSacrificeOutLeft.vue'
import ResultDetailSacrificeOutRight from '../components/ResultDetailSacrificeOutRight.vue'
//自己投資マインドの結果詳細
import ResultDetailInvestInLeft from '../components/ResultDetailInvestInLeft.vue'
import ResultDetailInvestInRight from '../components/ResultDetailInvestInRight.vue'
import ResultDetailInvestOutLeft from '../components/ResultDetailInvestOutLeft.vue'
import ResultDetailInvestOutRight from '../components/ResultDetailInvestOutRight.vue'
//コミュニケーションの結果詳細
import ResultDetailCommunicationInLeft from '../components/ResultDetailCommunicationInLeft.vue'
import ResultDetailCommunicationInRight from '../components/ResultDetailCommunicationInRight.vue'
import ResultDetailCommunicationOutLeft from '../components/ResultDetailCommunicationOutLeft.vue'
import ResultDetailCommunicationOutRight from '../components/ResultDetailCommunicationOutRight.vue'
//アウトプットの結果詳細
import ResultDetailOutputInLeft from '../components/ResultDetailOutputInLeft.vue'
import ResultDetailOutputInRight from '../components/ResultDetailOutputInRight.vue'
import ResultDetailOutputOutLeft from '../components/ResultDetailOutputOutLeft.vue'
import ResultDetailOutputOutRight from '../components/ResultDetailOutputOutRight.vue'
//最後に
import ResultDetailLastMessage from '../components/ResultDetailLastMessage.vue'


export default {
	name: 'ResultDetail',
	title: '診断結果詳細',
	components: {
		ResultDetailTitle,
		ResultDetailSacrificeInLeft,
		ResultDetailSacrificeInRight,
		ResultDetailSacrificeOutLeft,
		ResultDetailSacrificeOutRight,
		ResultDetailInvestInLeft,
		ResultDetailInvestInRight,
		ResultDetailInvestOutLeft,
		ResultDetailInvestOutRight,
		ResultDetailCommunicationInLeft,
		ResultDetailCommunicationInRight,
		ResultDetailCommunicationOutLeft,
		ResultDetailCommunicationOutRight,
		ResultDetailOutputInLeft,
		ResultDetailOutputInRight,
		ResultDetailOutputOutLeft,
		ResultDetailOutputOutRight,
		ResultDetailLastMessage,
	},
	
	data: function () {
		return {
			bgWidth:100,
			resultDetailNow:1,
		}
	},
	head: {
		title: {inner:'診断結果｜超詳細】内向型診断テスト「イントロバーツ」'},
		meta: [
			{ name: 'description', content: '断結果は5000字以上！今のあなたの内向度と、あなたの行動やマインドを総合的に分析し、あなたの内向性をビジネスやプライベートで生かすためのノウハウを丁寧にアドバイス！' },
			{ property: 'og:title', content: '診断結果｜【超詳細】内向型診断テスト「イントロバーツ」' },
			{ property: 'og:description', content: '断結果は5000字以上！今のあなたの内向度と、あなたの行動やマインドを総合的に分析し、あなたの内向性をビジネスやプライベートで生かすためのノウハウを丁寧にアドバイス！' },
			{ property: 'og:type', content: 'article' },
			{ property: 'og:url', content: 'https://introverts.jp/#/result-detail' },
			// { property: 'og:image', content: 'https://example.com/img/og.png' },
			// { name: 'twitter:card', content: 'summary' }
		]
	},
	methods:{
		resultDetailNowPlus:function(){
			let resultDetailNow= this.resultDetailNow;
			this.resultDetailNow = this.resultDetailNow+1;
			//ページトップ
			window.scrollBy({
				top: -document.body.clientHeight,
				behavior: 'smooth'
			});			
			return resultDetailNow;
		},
		resultDetailNowMinus:function(){
			let resultDetailNow= this.resultDetailNow;
			this.resultDetailNow = this.resultDetailNow-1;
			//ページトップ
			window.scrollBy({
				top: -document.body.clientHeight,
				behavior: 'smooth'
			});			
			return resultDetailNow;
		},		
		
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},		
		//sacrificeMind
		sacrificeMindResult:function(){
			return this.$store.getters.sacrificeMindResult
		},
		// investMind
		investMindResult:function(){
			return this.$store.getters.investMindResult
		},
		// communicate
		communicateResult:function(){
			return this.$store.getters.communicateResult
		},
		// output
		outputResult:function(){
			return this.$store.getters.outputResult
		},

	},
	created() {
		//alert('hoge is: ' + this.hoge);
		window.scrollBy({
			top: -document.body.clientHeight,
			behavior: 'smooth'
		});		
	},	
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
/*===================================================================
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □

〇 .result-detail pc 〇

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □      
====================================================================*/
.result-detail{
	.page-title{
		background:#359799;
		text-align: center;
		width:100%;
		padding:60px 0 0px 0;
		overflow: hidden;
		.wrapper{
			margin:50px auto 0px;
			display: flex;
			justify-content: center;
			&.last{
				flex-direction: row-reverse;
			}

			.text{
				width: 600px;
				margin:0 20px 0 0;
				h2{
					font-size:22px;
					color:#fff;
					letter-spacing: 2px;
					padding:0 0 7px 0;
				}
				h1{
					font-size:62px;
					color:#fff;
					letter-spacing: 2px;
					padding:0 0 7px 0;
				}
				.explain{
					font-size:17px;
					color:#fff;
					letter-spacing: 1px;
					font-weight: bold;
					width: 80%;
					margin:30px auto 0;
				}
			}
			.image{
				width:600px;
				height: auto;
				line-height: 0;
			}
		}

	}

	.subject{
		background: #359799;
		color: #fff;
		margin:50px 0 0 0;
		padding:50px 30px 50px 30px;
		&.last{
			margin:0px 0 0 0;	
		}
		h3{
			font-size:22px;
		}
		h2{
			margin:20px 0 0 0;
			font-size:38px;
		}
		.en{
			margin:10px 0 0 0;
			letter-spacing: 1px;
		}
	}
	




	.contents{
		padding:0px 0 50px 0;
		.mark{
			text-align: center;
			padding:10px 0 3px 0;
			font-weight: bold;
			position: relative;
			z-index: 3;
			background:#beeae9;
			margin:0px auto 10px;
			.type{
				text-align: center;
				margin:-35px auto 10px;
				display: block;
				span{
					display: inline-block;
					font-size:30px;
					background: #359799;
					color: #fff;
					border:solid 4px #ffff;
					border-radius: 90px;
					padding: 5px 35px 5px 35px;

				}
			}
			.cover{
				color: #359799;
				font-size:25px;
				padding:10px 0 10px 0;
			}


		}


		.sentence{
			text-align: left;
			max-width: 1000px;
			margin:0 auto 0;
			.catch{
				margin:40px 0 0 0;
				font-weight: bold;
				letter-spacing: 0.5px;
				.left{
					background:#359799;
					color:#fff;
					font-size:20px;
					padding:4px 20px 4px 20px;
					border-radius:40px;
				}
				.right{
					color:#359799;
					font-size:22px;
					padding:0 0 0 5px;
				}
			}
			.catch + h2{
				margin:10px 0 0px 0;
			}
			.semi{
				padding: 0 5% 0 5%;
				.cover{
					display: inline-block;
					border:solid 2px #359799;
					transform: skew(-15deg);
					padding:4px 10px 4px 10px;
					span{
						display: inline-block;
						transform: skew(15deg);
						font-size:18px;
						color:#359799;
					}


				}
			}

			h3.semi + h2{
				margin:0px 0 15px 0;
			}

			h2{
				color: #359799;
				font-size: 38px;
				font-family:"Meiryo UI" , "メイリオ" , Meiryo, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", Arial,sans-serif;
				margin: 40px 0 15px 0;
				text-align: left;
			}


			p{
				font-size: 20px;
				padding: 15px 0 15px 0;
				letter-spacing: 1px;
				line-height: 2.0;
				color: #3f3f3f;
				font-family:"Meiryo UI" , "メイリオ" , Meiryo, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", Arial,sans-serif;				
			}
			img.visual{
				width: 700px;
				height: auto;
				display: block;
				margin: 60px auto 0;
			}

			.caption{
				width: 700px;
				margin: 0 auto;
				text-align: left;
				font-family:"Meiryo UI" , "メイリオ" , Meiryo, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", Arial,sans-serif;
				color: #707070;
				text-align: center;
				padding: 10px 0 40px 0;
				font-size: 16px;
			}
			ul.check{
				li{
					margin:20px auto 0;
					text-align:left;
					font-family:"Meiryo UI" , "メイリオ" , Meiryo, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", Arial,sans-serif;
					font-size:20px;
					color: #28888a;
					font-weight: bold;
					background:#c7e8e9;
					position: relative;
					text-shadow: 0px 1px 0px rgba(255,255,255,0.7);
					position: relative;
					&:before,
					&:after{
						content:"";
						position: absolute;
						width:20px;
						height: 20px;
					}
										
					&:before{
						left:0;
						top:0;
						border-left:solid 4px #359799;;
						border-top:solid 4px #359799;
					}
					&:after{
						right:0;
						bottom:0;
						border-right:solid 4px #359799;;
						border-bottom:solid 4px #359799;
					}
					.text{
						padding:20px 20px 20px 20px;
						text-align: center;
					}

				}
			}
		}
	}

	/*==============================================
	アイコンの大きさ個別指定
	===============================================*/	

	.sacrifice-mind{
		.contents{
			.mark{
				img{
					width:40px;
					height:auto;
					padding:0 3px 0 0;
					position: relative;
					top:2px;

				}
			}
		}
	}
	.invest-mind{
		.contents{
			.mark{
				img{
					width:40px;
					height:auto;
					padding:0 3px 0 0;
					position: relative;
					top:3px;

				}
			}
		}
	}

	.communication{
		.contents{
			.mark{
				img{
					width:40px;
					height:auto;
					padding:0 3px 0 0;
					position: relative;
					top:3px;

				}
			}
		}
	}	

	.output{
		.contents{
			.mark{
				img{
					width:40px;
					height:auto;
					padding:0 3px 0 0;
					position: relative;
					top:3px;

				}
			}
		}
	}		

	/*==============================================
	variables(変数設定)
	===============================================*/
	$next-color:#269c9f;
	$prev-color:#5f394d;

	.next{
		width: 360px!important;
		margin:20px auto 45px;
		display: block;
		background:$next-color;
		color:#fff;
		font-size:25px;
		text-align: center;
		border-radius:30px;
		padding:14px 20px 14px 5px;
		box-shadow: 0 2px 25px rgba(204, 204, 204, 0.5);
		position: relative;
		z-index: 1;
		text-decoration: none;
	}

	.next::before{
		content:"";
		display: inline-block;
		position:absolute;
		top:50%;
		transform: translateY(-50%);
		right:20px;
		width: 22px;
		height: 22px;
		z-index: 2;
		background-image:url(../assets/next.svg);
		background-repeat:no-repeat;
		background-position: right center;
		background-size:auto 22px;
	}

	.prev{
		font-size:17px;
		display: block;
		margin: 0 auto 20px;
		text-align: center;
		color:#fff;
		background:$prev-color;
		width: 180px;
		padding:7px 5px 7px 5px;
		font-size:18px;
		border-radius:30px;
		position: relative;
		text-decoration: none;
	}

	.prev::before{
		content:"";
		display: inline-block;
		position:absolute;
		top:50%;
		transform: translateY(-50%) rotate(-180deg);
		left:15px;
		width: 16px;
		height: 16px;
		z-index: 2;
		background-image:url(../assets/next.svg);
		background-repeat:no-repeat;
		background-position: right center;
		background-size:auto 16px;
	}

	h4.next-catch{
		color: #359799;
		font-size:18px;
	}
} 


/**********************************************************************************
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □  

◆	Stylesheet: 768px～1023px(iPad縦からiPad横)までのモニタで適用	◆

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
start----------------------------------------------------------------------------*/
@media screen and (min-width: 768px) and (max-width: 1023px) {
	.result-detail{
		.page-title{
			padding:30px 0 0px 0;
			overflow: hidden;
			.wrapper{
				margin:20px auto 0px;
				display: block;

				.text{
					width: 100%;
					margin:0 20px 0 0;
					h2{
						font-size:3vw;
						padding:0 0 7px 0;
					}
					h1{
						font-size:6.5vw;
						padding:0 0 7px 0;
					}
					.explain{

						font-size:2.25vw;
						width: 60%;
						margin:20px auto 0;
					}
				}
				.image{
					width:55vw;
					margin:20px auto 0;
					height: auto;
					line-height: 0;
				}
			}

		}

		.subject{
			background: #359799;
			color: #fff;
			margin:50px 0 0 0;
			padding:50px 30px 50px 30px;
			&.last{
				margin:0px 0 0 0;	
			}
			h3{
				font-size:22px;
			}
			h2{
				margin:20px 0 0 0;
				font-size:38px;
			}
			.en{
				margin:10px 0 0 0;
				letter-spacing: 1px;
			}
		}
		




		.contents{
			padding:0px 0 50px 0;
			.mark{
				text-align: center;
				margin:0px auto 10px;
				.type{
					text-align: center;
					margin:-35px auto 10px;
					display: block;
					span{

						font-size:3vw;
						padding: 5px 35px 5px 35px;

					}
				}
				.cover{
					color: #359799;
					font-size:25px;
					padding:10px 0 10px 0;
				}


			}


			.sentence{
				padding:0 5% 0 5%;
				.catch{
					margin:40px 0 0 0;
					font-weight: bold;
					letter-spacing: 0.5px;
					.left{
						background:#359799;
						color:#fff;
						font-size:20px;
						padding:4px 20px 4px 20px;
						border-radius:40px;
					}
					.right{
						color:#359799;
						font-size:22px;
						padding:0 0 0 5px;
					}
				}
				.catch + h2{
					margin:10px 0 0px 0;
				}
				.semi{
					padding: 0 5% 0 5%;
					.cover{
						display: inline-block;
						border:solid 2px #359799;
						transform: skew(-15deg);
						padding:4px 10px 4px 10px;
						span{
							display: inline-block;
							transform: skew(15deg);
							font-size:18px;
							color:#359799;
						}


					}
				}

				h3.semi + h2{
					margin:0px 0 15px 0;
				}

				h2{

					font-size: 4.25vw;
				}


				p{
					font-size: 2.25vw;
				}
				img.visual{
					width: 700px;
					height: auto;
					display: block;
					margin: 60px auto 0;
				}

				.caption{
					width:450px;
					padding:10px 0 40px 0;
					font-size:1.8vw;
				}
				ul.check{
					li{
						margin:20px auto 0;
						text-align:left;
						font-family:"Meiryo UI" , "メイリオ" , Meiryo, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", Arial,sans-serif;
						font-size:20px;
						color: #28888a;
						font-weight: bold;
						background:#c7e8e9;
						position: relative;
						text-shadow: 0px 1px 0px rgba(255,255,255,0.7);
						position: relative;
						&:before,
						&:after{
							content:"";
							position: absolute;
							width:20px;
							height: 20px;
						}
											
						&:before{
							left:0;
							top:0;
							border-left:solid 4px #359799;;
							border-top:solid 4px #359799;
						}
						&:after{
							right:0;
							bottom:0;
							border-right:solid 4px #359799;;
							border-bottom:solid 4px #359799;
						}
						.text{
							padding:20px 20px 20px 20px;
							text-align: center;
						}

					}
				}
			}
		}

		/*==============================================
		アイコンの大きさ個別指定
		===============================================*/	

		.sacrifice-mind{
			.contents{
				.mark{
					img{
						width:5vw;
						height:auto;
						padding:0 3px 0 0;
						position: relative;
						top:0.3vw;

					}
				}
			}
		}
		.invest-mind{
			.contents{
				.mark{
					img{
						width:5vw;
						height:auto;
						padding:0 3px 0 0;
						position: relative;
						top:0.3vw;

					}
				}
			}
		}

		.communication{
			.contents{
				.mark{
					img{
						width:5vw;
						height:auto;
						padding:0 3px 0 0;
						position: relative;
						top:0.3vw;

					}
				}
			}
		}	

		.output{
			.contents{
				.mark{
					img{
						width:5vw;
						height:auto;
						padding:0 3px 0 0;
						position: relative;
						top:0.3vw;

					}
				}
			}
		}		

		/*==============================================
		variables(変数設定)
		===============================================*/


		.next{
			width: 360px!important;
			margin:20px auto 45px;
			font-size:25px;
			border-radius:60px;
			padding:14px 20px 14px 5px;

		}

		.next::before{
			content:"";
			right:20px;
			width: 22px;
			height: 22px;
			z-index: 2;
			background-size:auto 22px;
		}

		.prev{
			font-size:17px;
			display: block;
			margin: 0 auto 20px;
			width: 180px;
			padding:7px 5px 7px 5px;
			font-size:18px;
			border-radius:60px;
		}

		.prev::before{
			content:"";
			top:50%;
			left:15px;
			width: 16px;
			height: 16px;
			background-size:auto 16px;
		}

		h4.next-catch{

			font-size:18px;
		}
	} 
} /* 768px～1023px responsive-closed */


/**********************************************************************************
 □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 

◆	Stylesheet: 767pxまで(スマホ)のモニタで適用	◆

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
start----------------------------------------------------------------------------*/
@media screen and (max-width: 767px) {
	.result-detail{
		.page-title{
			padding:40px 0 0px 0;
			.wrapper{
				margin:0px auto 0px;
				display: block;
				.text{
					width: 92%;
					margin:0 auto 30px;
					h2{
						font-size:4.25vw;
						padding:0 0 5px 0;
					}
					h1{
						font-size:9vw;
						letter-spacing: 1px;
						padding:0 0 7px 0;
					}
					.explain{
						font-size:3.75vw;
						width: 80%;
						margin:15px auto 0;
					}
				}
				.image{
					width:95%;
					margin:0 auto 0;
				}
			}
		}


		.subject{

			margin:50px 0 0 0;
			padding:50px 30px 50px 30px;
			&.last{
				margin:0px 0 0 0;	
			}
			h3{
				font-size:4.5vw
			}
			h2{
				margin:20px 0 0 0;
				font-size:6vw;
			}
			.en{
				margin:10px 0 0 0;
				letter-spacing: 1px;
				font-size:3.75vw
			}
		}	
		.contents{
			padding:0px 0 10px 0;
			.mark{
				background:#beeae9;
				margin:0px auto 0px;
				padding:15px 5% 10px 5%;
				
				.type{
					text-align: center;
					margin:-35px auto 5px;
					display: block;
					span{
						display: inline-block;
						font-size:4.55vw;
						background: #359799;
						color: #fff;
						border:solid 3px #ffff;
						border-radius: 90px;
						padding: 5px 35px 5px 35px;

					}

				}
				.cover{
					font-size:20px;
					padding:5px 0 5px 0;
					font-size:4.55vw;
				}
			}
			.sentence{
				text-align: left;
				margin:0 auto 0;

				.catch{
					margin:30px 0 0 0;
					padding: 0 5% 0 5%;
					letter-spacing: 0.5px;
					.left{
						background:#359799;
						color:#fff;
						font-size:4vw;
						padding:4px 20px 4px 20px;
						border-radius:40px;
					}
					.right{
						color:#359799;
						font-size:4.25vw;
						padding:0 0 0 5px;
					}
				}
				.catch + h2{
					margin:5px 0 0px 0;
				}


				h3.mark + h2{
					margin:10px 0 15px 0;
				}

				h2{
					font-size:6.5vw;
					margin: 30px 0 15px 0;
					padding:5px 5% 0 5%;
				}


				p{
					font-size:4.0vw;
					line-height: 2.0;
					padding: 15px 5% 15px 5%;
					letter-spacing: 0.25px;
				}
				img.visual{
					width: 90%;
					margin: 40px auto 0;
				}

				.caption{
					width: 80%;
					text-align: center;
					font-size: 3.25vw;
					padding: 10px 0 20px 0;
				}
				ul.check{
					li{
						margin:20px auto 0;
						font-size:3.9vw;


						&:before,
						&:after{
							content:"";
							position: absolute;
							width:20px;
							height: 20px;
						}
											
						&:before{
							left:0;
							top:0;
							border-left:solid 3px #359799;;
							border-top:solid 3px #359799;
						}
						&:after{
							right:0;
							bottom:0;
							border-right:solid 3px #359799;;
							border-bottom:solid 3px #359799;
						}
						.text{
							padding:20px 20px 20px 20px;
							text-align: center;
						}

					}
				}
			}
		}

		/*==============================================
		アイコンの大きさ個別指定
		===============================================*/	

		.sacrifice-mind{
			.contents{
				.mark{
					img{
						width:6.25vw;
						height:auto;
						padding:0 3px 0 0;

					}
				}
			}
		}
		.invest-mind{
			.contents{
				.mark{
					img{
						width:6.25vw;
						height:auto;
						padding:0 3px 0 0;
						position: relative;
						top:3px;
					}
				}
			}
		}

		.communication{
			.contents{
				.mark{
					img{
						width:6.25vw;
						height:auto;
						padding:0 3px 0 0;
						position: relative;
						top:3px;
					}
				}
			}
		}	

		.output{
			.contents{
				.mark{
					img{
						width:6.25vw;
						height:auto;
						padding:0 3px 0 0;
						position: relative;
						top:3px;
					}
				}
			}
		}		

		h4.next-catch{
			font-size:4vw;
			margin:20px auto 0;
			padding:0 5% 0 5%;
			font-weight: bold;
		}
		.next{
			width: 87.5%!important;
			font-size:5.5vw;
			margin:20px auto 25px;
			
		}
	} 

} /* 767px responsive-closed */

/*end ----------------------------------------------------------------------------
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
**********************************************************************************/


/**********************************************************************************
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □   

◆	Stylesheet: さらに刻んで320pxまでのモニタで適用	◆

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
start----------------------------------------------------------------------------*/

@media screen and (max-width: 320px) {
	/*==============================================
	.summary
	===============================================*/

} /* 320px responsive-closed */

/*end ----------------------------------------------------------------------------
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
**********************************************************************************/

</style>
